import React from "react";
import Footer from "../../Footer/Footer";
import Blogs from "../Blogs/Blogs";
import Contact from "../Contact/Contact";
import Projects from "../Projects/Projects";
import About from "./About";
import Banner from "./Banner";
import Header from "./Header";

const Home = () => {
  return (
        <div id="home" className="container mx-auto">
        <Header></Header>
        <Banner></Banner>
        <About></About>
        <Projects></Projects>
        <Blogs></Blogs>
        <Contact></Contact>
        <Footer></Footer>
      </div>
  );
};

export default Home;
